import { teacherPostLoginPath } from "./teacherLoginRedirect";
import { resolveSchoolVerificationStatus } from "./schoolVerification";

/** Normalize API / stored role strings for routing. */
export function normalizeRole(role) {
    const r = String(role || "").trim();
    if (!r) return null;
    const lower = r.toLowerCase();
    if (lower === "admin") return "Admin";
    if (lower === "student") return "Student";
    if (lower === "teacher") return "Teacher";
    if (lower === "system") return "System";
    if (r === "Admin" || r === "Student" || r === "Teacher" || r === "System") return r;
    return null;
}

export function getEffectiveRole(currentRole, currentUser) {
    return normalizeRole(currentRole || currentUser?.role);
}

export function getDashboardPathForRole(role, user) {
    const r = normalizeRole(role);
    if (r === "Admin") {
        if (resolveSchoolVerificationStatus(user) === "pending") {
            return "/Admin/pending-verification";
        }
        return "/Admin/dashboard";
    }
    if (r === "Student") return "/Student/dashboard";
    if (r === "Teacher") return teacherPostLoginPath(user);
    if (r === "System") return "/System/dashboard";
    return null;
}
